// extracted by mini-css-extract-plugin
module.exports = {"loader":"SpinnerCircle_loader__3OJI0","load8":"SpinnerCircle_load8__2uEdN"};